export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResetPwd.vue?vue&type=template&id=9f5fb422&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/ResetPwd.vue?vue&type=template&id=9f5fb422&
// module id = null
// module chunks = 